import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetRemoteUrlService extends Service {
  constructor({requestFactory, repository}) {
    super()
    this._requestFactory = requestFactory
    this._repository = repository
  }

  @inlineError
  async execute({urlType, params}) {
    const remoteUrlRequest = this._requestFactory({
      items: [
        {
          urlType,
          data: params
        }
      ]
    })
    const [error, remoteUrlVO] = await this._repository.getRemoteUrl({
      remoteUrlRequest
    })

    if (error) return Promise.reject(error)

    return remoteUrlVO
  }
}
